/* global axios */
import ApiClient from './ApiClient';

class PendingMarketUpdatesAPI extends ApiClient {
  constructor() {
    super('pending_market_updates', { accountScoped: true });
  }

  kinds() {
    return axios.get(`${this.url}/kinds`);
  }

  items(params = {}) {
    return axios.get(`${this.url}/items`, { params });
  }

  item(itemId) {
    return axios.get(`${this.url}/items/${itemId}`);
  }

  operations(params = {}) {
    return axios.get(`${this.url}/operations`, { params });
  }

  updateMidas(itemId, payload = {}) {
    return axios.post(`${this.url}/items/${itemId}/update_midas`, payload);
  }

  midasOptionists() {
    return axios.get(`${this.url}/midas/optionists`);
  }

  midasLaudoPreview(itemId, params = {}) {
    return axios.get(
      `${this.url}/items/${itemId}/register_laudo_midas/preview`,
      { params }
    );
  }

  registerLaudoMidas(itemId, payload = {}) {
    return axios.post(
      `${this.url}/items/${itemId}/register_laudo_midas`,
      payload
    );
  }

  refuse(itemId, payload = {}) {
    return axios.post(`${this.url}/items/${itemId}/refusal`, payload);
  }

  blacklist(params = {}) {
    return axios.get(`${this.url}/blacklist`, { params });
  }

  createBlacklist(payload = {}) {
    return axios.post(`${this.url}/blacklist`, payload);
  }

  deactivateBlacklist(entryId, payload = {}) {
    return axios.post(`${this.url}/blacklist/${entryId}/deactivate`, payload);
  }

  blockOwnerPhone(itemId, payload = {}) {
    return axios.post(
      `${this.url}/items/${itemId}/owner_phone_blacklist`,
      payload
    );
  }
}

export default new PendingMarketUpdatesAPI();
